export const UPDATE_QUADRANT_I = 'update_quadrant_i';
export const UPDATE_QUADRANT_II = 'update_quadrant_ii';
export const UPDATE_QUADRANT_III = 'update_quadrant_iii';
export const UPDATE_QUADRANT_IV = 'update_quadrant_iv';
export const UPDATE_SITE = 'update_site';
export const UPDATE_METADATA = 'update_metadata';
export const TOGGLE_SLIDER = 'toggle_slider';